import React from 'react'
import { css } from '@emotion/core'
import Link from '../link'
import { bpMaxSM } from '~lib/breakpoints'
import Container from '../container'
import timeAgoFormat, { timeStr } from '../../utils/timeago'

import { fetchReadingList } from '~lib/parser'


export default class RecentReading extends React.Component {
  state = {
    entryList: [],
  }
  componentDidMount() {
    try {
      fetchReadingList(this.props.hideAll ? 30 : 10).then(response => {
        console.log(response)
        this.processData(response)
      })
    } catch (error) { }
  }
  processData = response => {
    console.log('response')
    console.log(response)
    if (response && Array.isArray(response))
      this.setState({ entryList: response })
  }
  render() {
    if (this.state.entryList && this.state.entryList.length == 0) return null
    return (
      <Container
        css={css`
          margin-top: -40px;
        `}
      >
        <h3
          css={css`
            display: flex;
            justify-content: space-between;
          `}
        >
          <span>👍 我最近点赞的文章</span>
          {this.props.hideAll ? null : (
            <span
              css={css`
                text-align: center;
                font-size: 15px;
              `}
            >
              <Link to="/readings">查看全部最近阅读</Link>
            </span>
          )}
        </h3>
        <ul className="with-mark-link">
          {this.state.entryList.map((entry, i) => {
            const time = new Date(entry.attributes.time)
            return (
              <li
                css={css`
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                `}
                key={entry.id}
              >
                <span
                  css={css`
                    min-width: 0;
                    overflow: hidden;
                    flex: 1;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-right: 15px;
                  `}
                >
                  <a rel="noopener noreferrer" target="_blank" href={entry.attributes.originUrl}>
                    {entry.attributes.type ? `[${entry.attributes.type}] ` : ''}
                    {entry.attributes.title}
                  </a>
                </span>
                <span css={css`font-size: 14px;`} title={timeStr(time)}>{timeAgoFormat(time).replace(/^\s?20/, '').replace(/(\d{1,2}):(\d{1,2}):\d{1,2}/, '$1:$2')}</span>
              </li>
            )
          })}
        </ul>
      </Container>
    )
  }
}
